import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-gurvinder',
  templateUrl: './gurvinder.component.html',
  styleUrls: ['./gurvinder.component.scss']
})
export class GurvinderComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getGurvinder();
  }


}
